/* eslint-disable camelcase */
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

const DocumentDetails = ({
  Details,
}) => {
  const { RL_DocumentNumber, RL_DocumentType } = useSelector((state) => state);

  return (
    <>
      {Details?.map((document) => (
        <section key={`${document?.DocumentNo}`}>
          <article className="justify-between">
            <p>{RL_DocumentNumber} {document.DocumentNo}</p>
          </article>
          <article className="justify-between">
            <p>{RL_DocumentType}: {document.DocumentType}</p>
          </article>
        </section>
      ))}
      <br />
    </>
  );
};

DocumentDetails.defaultProps = {
  Details: [],
};

DocumentDetails.propTypes = {
  Details: PropTypes.arrayOf(PropTypes.shape()),
};

export default DocumentDetails;
